import { profilesApi } from "@/api";

export const verifyOTPForProfile = (_: string, code: string) =>
    profilesApi.verifyOTPForProfile(code)
